import "./App.css";
import "./Styles/navbar.css";
import Navbar from "./Components/Navbar";
import AllRoutes from "./Components/AllRoutes";

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
